// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Element from "./element.js"
import ElementFeedback from "./element-feedback.js"
import ElementFeedbackOption from "./element-feedback-option.js"
import FeedbackAnswer from "./feedback-answer.js"
import FeedbackStep from "./feedback-step.js"

const modelClassData = {
  "attributes": {
    "elaboration": {
      "column": {
        "default": null,
        "name": "elaboration",
        "null": true,
        "type": "text"
      },
      "name": "elaboration",
      "selected_by_default": null,
      "translated": null
    },
    "element_feedback_id": {
      "column": {
        "default": null,
        "name": "element_feedback_id",
        "null": false,
        "type": "uuid"
      },
      "name": "element_feedback_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "FeedbackElement",
  "collectionKey": "feedback_elements",
  "collectionName": "feedback_elements",
  "i18nKey": "feedback_element",
  "camelizedLower": "feedbackElement",
  "name": "FeedbackElement",
  "nameDasherized": "feedback-element",
  "pluralName": "feedback_elements",
  "ransackable_associations": [
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "has_one",
      "resource_name": "Element",
      "through": "element_feedback"
    },
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "element_feedback_id",
      "name": "element_feedback",
      "macro": "belongs_to",
      "resource_name": "ElementFeedback",
      "through": null
    },
    {
      "className": "ElementFeedbackOption",
      "collectionName": "element_feedback_options",
      "foreignKey": "element_feedback_option_id",
      "name": "element_feedback_options",
      "macro": "has_many",
      "resource_name": "ElementFeedbackOption",
      "through": "feedback_answers"
    },
    {
      "className": "FeedbackAnswer",
      "collectionName": "feedback_answers",
      "foreignKey": "feedback_element_id",
      "name": "feedback_answers",
      "macro": "has_many",
      "resource_name": "FeedbackAnswer",
      "through": null
    },
    {
      "className": "FeedbackAssignment",
      "collectionName": "feedback_assignments",
      "foreignKey": "feedback_assignment_id",
      "name": "feedback_assignment",
      "macro": "has_one",
      "resource_name": "FeedbackAssignment",
      "through": "feedback_step"
    },
    {
      "className": "FeedbackStep",
      "collectionName": "feedback_steps",
      "foreignKey": "feedback_step_id",
      "name": "feedback_step",
      "macro": "belongs_to",
      "resource_name": "FeedbackStep",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "has_one",
      "resource_name": "Step",
      "through": "element"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_to_feedback_id",
      "name": "team_survey_to_feedback",
      "macro": "has_one",
      "resource_name": "TeamSurvey",
      "through": "feedback_step"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "elaboration",
      "column": {
        "default": null,
        "name": "elaboration",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "element_feedback_id",
      "column": {
        "default": null,
        "name": "element_feedback_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "feedback_step_id",
      "column": {
        "default": null,
        "name": "feedback_step_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_element_feedback_id",
      "column": {
        "default": null,
        "name": "old_element_feedback_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_feedback_step_id",
      "column": {
        "default": null,
        "name": "old_feedback_step_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "has_one",
      "resource_name": "Element",
      "through": "element_feedback"
    },
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "element_feedback_id",
      "name": "element_feedback",
      "macro": "belongs_to",
      "resource_name": "ElementFeedback",
      "through": null
    },
    {
      "className": "ElementFeedbackOption",
      "collectionName": "element_feedback_options",
      "foreignKey": "element_feedback_option_id",
      "name": "element_feedback_options",
      "macro": "has_many",
      "resource_name": "ElementFeedbackOption",
      "through": "feedback_answers"
    },
    {
      "className": "FeedbackAnswer",
      "collectionName": "feedback_answers",
      "foreignKey": "feedback_element_id",
      "name": "feedback_answers",
      "macro": "has_many",
      "resource_name": "FeedbackAnswer",
      "through": null
    },
    {
      "className": "FeedbackStep",
      "collectionName": "feedback_steps",
      "foreignKey": "feedback_step_id",
      "name": "feedback_step",
      "macro": "belongs_to",
      "resource_name": "FeedbackStep",
      "through": null
    }
  ],
  "paramKey": "feedback_element",
  "primaryKey": "id"
}

/** Frontend model for FeedbackElement. */
export default class FeedbackElement extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  elaboration() {
    return this.readAttributeUnderscore("elaboration")
  }

  /** @returns {boolean} */
  hasElaboration() {
    const value = this.elaboration()

    return this._isPresent(value)
  }

  /** @returns {string} */
  elementFeedbackId() {
    return this.readAttributeUnderscore("element_feedback_id")
  }

  /** @returns {boolean} */
  hasElementFeedbackId() {
    const value = this.elementFeedbackId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {import("./element.js").default | null} */
  element() {
    return this._readHasOneReflection({modelClass: Element, reflectionName: "element"})
  }

  /** @returns {Promise<import("./element.js").default | null>} */
  loadElement() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "element",
        model: this,
        modelClass: Element
      },
      {
        params: {
          through: {
            model: "FeedbackElement",
            id,
            reflection: "element"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./element.js").default | null>} */
  ensureElementLoaded() {
    return this.ensureAssociationLoaded("element")
  }

  /** @returns {import("./element-feedback.js").default | null} */
  elementFeedback() {
    return this._readBelongsToReflection({modelClass: ElementFeedback, reflectionName: "element_feedback"})
  }

  /** @returns {Promise<import("./element-feedback.js").default | null>} */
  loadElementFeedback() {
    if (!("elementFeedbackId" in this)) throw new Error("Foreign key method wasn't defined: elementFeedbackId")

    const id = this.elementFeedbackId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "element_feedback",
        model: this,
        modelClass: ElementFeedback
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./element-feedback.js").default | null>} */
  ensureElementFeedbackLoaded() {
    return this.ensureAssociationLoaded("element_feedback")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./element-feedback-option.js").default>} */
  elementFeedbackOptions() {
    return new Collection(
      {
        reflectionName: "element_feedback_options",
        model: this,
        modelClass: ElementFeedbackOption
      },
      {
        params: {
          through: {
            model: "FeedbackElement",
            id: this.primaryKey(),
            reflection: "element_feedback_options"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./element-feedback-option.js").default>>} */
  loadElementFeedbackOptions() {
    return this._loadHasManyReflection(
      {
        reflectionName: "element_feedback_options",
        model: this,
        modelClass: ElementFeedbackOption
      },
      {
        params: {
          through: {
            model: "FeedbackElement",
            id: this.primaryKey(),
            reflection: "element_feedback_options"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./element-feedback-option.js").default>>} */
  ensureElementFeedbackOptionsLoaded() {
    return this.ensureAssociationLoaded("element_feedback_options")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./feedback-answer.js").default>} */
  feedbackAnswers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["feedback_element_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "feedback_answers",
        model: this,
        modelClass: FeedbackAnswer
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./feedback-answer.js").default>>} */
  loadFeedbackAnswers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["feedback_element_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "feedback_answers",
        model: this,
        modelClass: FeedbackAnswer
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./feedback-answer.js").default>>} */
  ensureFeedbackAnswersLoaded() {
    return this.ensureAssociationLoaded("feedback_answers")
  }

  /** @returns {import("./feedback-step.js").default | null} */
  feedbackStep() {
    return this._readBelongsToReflection({modelClass: FeedbackStep, reflectionName: "feedback_step"})
  }

  /** @returns {Promise<import("./feedback-step.js").default | null>} */
  loadFeedbackStep() {
    if (!("feedbackStepId" in this)) throw new Error("Foreign key method wasn't defined: feedbackStepId")

    const id = this.feedbackStepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "feedback_step",
        model: this,
        modelClass: FeedbackStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./feedback-step.js").default | null>} */
  ensureFeedbackStepLoaded() {
    return this.ensureAssociationLoaded("feedback_step")
  }
}
